(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(){
    var els = document.querySelectorAll('.rivea-reveal');
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('rivea-in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('rivea-in'); io.unobserve(en.target);} });
    }, {threshold: 0.12});
    els.forEach(function(e){ io.observe(e); });
  }
  function ba(){
    document.querySelectorAll('.rivea-ba').forEach(function(el){
      var input = el.querySelector('input[type=range]');
      if(!input) return;
      var set = function(){ el.style.setProperty('--ba', input.value + '%'); };
      input.addEventListener('input', set); set();
    });
  }
  if(document.readyState !== 'loading'){ reveal(); ba(); }
  else document.addEventListener('DOMContentLoaded', function(){ reveal(); ba(); });
  document.addEventListener('shopify:section:load', function(){ reveal(); ba(); });
})();
